var map = {
	"./authority.svg": "zcBC",
	"./check.svg": "JmKx",
	"./date.svg": "58/F",
	"./delete.svg": "JQuL",
	"./deliver.svg": "fyRE",
	"./export.svg": "j83p",
	"./file.svg": "UdaO",
	"./gsp.svg": "ycDl",
	"./marketing.svg": "3aiK",
	"./medical_record.svg": "FVzS",
	"./member.svg": "GyY2",
	"./news.svg": "4CLQ",
	"./orderIcon.svg": "Hba1",
	"./package.svg": "8XOL",
	"./password.svg": "mjfm",
	"./phone.svg": "rYc7",
	"./prescription.svg": "uhk4",
	"./price.svg": "iTj6",
	"./print.svg": "oYoM",
	"./prompt.svg": "yp1C",
	"./purchase.svg": "1rsk",
	"./quality.svg": "973H",
	"./recently.svg": "NIcp",
	"./report.svg": "PzDz",
	"./retail.svg": "FcTx",
	"./screen.svg": "ocd9",
	"./stock.svg": "7E4c",
	"./store.svg": "NbPw",
	"./system.svg": "6LJl",
	"./template.svg": "cYVM",
	"./tidings.svg": "N9iA",
	"./user.svg": "ZYbq",
	"./warehouse.svg": "R6mf",
	"./warning.svg": "IWb6",
	"./wholesale.svg": "uo30"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V9+J";


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg nonrecursive \.svg$
// module id = V9+J
// module chunks = 35